import React from 'react';
import Footer from "../components/Footer";

function Terms() {
  return (
    <>
      <div className="bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-3xl px-6 lg:px-8">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Terms of Service</h1>
          <p className="mt-2 text-sm text-gray-500">Effective date: January 1, {new Date().getFullYear()}</p>

          <div className="mt-10 space-y-8 text-base leading-7 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900">Agreement to Terms</h2>
              <p className="mt-3">
                By accessing or using the Astoria Labs website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Services</h2>
              <p className="mt-3">
                Astoria Labs provides technology consulting services. The specific scope, deliverables, and terms of any engagement will be defined in a separate agreement between Astoria Labs and the client.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Use of the Site</h2>
              <p className="mt-3">
                You agree to use this site only for lawful purposes and in a manner that does not infringe the rights of, or restrict or inhibit the use of this site by, any third party. You may not use the site to transmit any harmful, offensive, or disruptive content.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Intellectual Property</h2>
              <p className="mt-3">
                All content on this site, including text, graphics, logos, and software, is the property of Astoria Labs or its content suppliers and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works from any content on this site without prior written consent.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Limitation of Liability</h2>
              <p className="mt-3">
                Astoria Labs provides this site and its content on an "as is" basis. To the fullest extent permitted by law, Astoria Labs disclaims all warranties, express or implied, and shall not be liable for any damages arising from your use of the site or services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Third-Party Links</h2>
              <p className="mt-3">
                This site may contain links to third-party websites. Astoria Labs is not responsible for the content or practices of any linked sites and provides these links for convenience only.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Changes to These Terms</h2>
              <p className="mt-3">
                We may update these Terms of Service from time to time. Continued use of the site after any changes constitutes your acceptance of the revised terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Governing Law</h2>
              <p className="mt-3">
                These terms shall be governed by and construed in accordance with applicable law, without regard to conflict of law principles.
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Terms;
